import { useQuery } from '@tanstack/react-query';
import { metricsApi, type MetricsTab } from '@/api/metrics.api';

export const metricsKeys = {
  all: ['metrics'] as const,
  tab: (tab: MetricsTab) => [...metricsKeys.all, tab] as const,
  funnel: () => [...metricsKeys.all, 'funnel'] as const,
};

export function useMetrics(tab: MetricsTab, fromDate?: string, toDate?: string) {
  return useQuery({
    queryKey: [...metricsKeys.tab(tab), fromDate ?? '', toDate ?? ''],
    queryFn: () => metricsApi.query(tab, fromDate, toDate),
  });
}

export function useFunnel() {
  return useQuery({
    queryKey: metricsKeys.funnel(),
    queryFn: () => metricsApi.funnel(),
  });
}
